import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const compnayTreeApi = factory.get("compnay_tree");

const initialState = {
  company_tree: {
    nodes: [],
    departments: [],
    loading: false,
    is_company_tree_page: false,
  },
};

export const companyTreeSlice = createSlice({
  name: "companyTree",
  initialState,
  reducers: {
    setLoading(state, payload) {
      state.company_tree.loading = !state.company_tree.loading;
    },
    setCompanyTree: (state, { payload }) => {
      state.company_tree.nodes = [];
      state.company_tree.departments = [];

      payload.users.map((item) => {
        let emp_obj = {
          ...item,
          img: item.profile_pic ? item.profile_pic.replace("-test", "") : "",
        };
        state.company_tree.nodes.push(emp_obj);
      });

      state.company_tree.nodes = [
        ...payload.departments,
        ...state.company_tree.nodes,
      ];

      state.company_tree.departments = payload.departments;
      state.company_tree.loading = false;
    },
    setIsCompanyTreePage: (state, { payload }) => {
      if (payload !== undefined) {
        state.company_tree.is_company_tree_page = payload;
      } else {
        state.company_tree.is_company_tree_page =
          !state.company_tree.is_company_tree_page;
      }
    },
  },
});

export const { setLoading, setCompanyTree, setIsCompanyTreePage } =
  companyTreeSlice.actions;
export default companyTreeSlice.reducer;

//axios
const getTreeById = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading());
    const res = await compnayTreeApi.getById(id);
    dispatch(setCompanyTree(res.data.data));
  } catch (err) {
    dispatch(setLoading());
    throw new Error(err);
  }
};

export const CompanyTree = {
  getTreeById,
};
